module.exports = __webpack_public_path__ + "img/logo.5b6cf8ef.png";